import { createAction } from '@reduxjs/toolkit';
import { Modal } from '../../types/Models/Modal/Modal';

export const REMOVE_MODAL = 'REMOVE_MODAL';

export const removeModal = createAction(
    REMOVE_MODAL,
    (id: Modal['id']) => ({ payload: id }),
);
